import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import { TablePagination } from '@material-ui/core';
import cx from 'classnames';
import ToggleBtn from 'ui/components/toggle-button';
import PopupDialog from 'ui/components/popup-dialog';
import Progress from '../ui/react-ui/progress.jsx';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table';
import SearchBar from '../ui/searchBar';
import BillboardEdit from './billboard-edit';
import BillboardTypeSetting from './billboard-type-setting'; // api

import { getBillboardList, editBillboardAPI, deleteMultipleBillboardAPI, getBillboardTypeList } from '../../api/settingAPI';
import { setBillboardTypeList } from '../../redux/app';
var t = i18n.getFixedT(null, 'setting-billboard');
var gt = i18n.getFixedT(null, 'app');
var initImagesData = Array.from({
  length: 3
}, function (_, index) {
  return {
    imageFile: null,
    imageBase64: '',
    imagePath: '',
    show: false,
    keyNumber: index + 1
  };
});

var Billboard = function Billboard(props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      billboardTypeList = _useSelector.app.billboardTypeList;

  var dispatch = useDispatch();
  var id = props.id;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      curTypeId = _useState2[0],
      setCurTypeId = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      totalCount = _useState4[0],
      setTotalCount = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentPage = _useState6[0],
      setCurrentPage = _useState6[1];

  var _useState7 = useState(10),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      keyword = _useState10[0],
      setKeyword = _useState10[1];

  var _useState11 = useState({}),
      _useState12 = _slicedToArray(_useState11, 2),
      tableData = _useState12[0],
      setTableData = _useState12[1];

  var _useState13 = useState({
    field: 'beginTime',
    desc: true
  }),
      _useState14 = _slicedToArray(_useState13, 2),
      tableSort = _useState14[0],
      setTableSort = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      selectedItems = _useState16[0],
      setSelectedItems = _useState16[1];

  var initDialogData = {
    mode: '',
    data: {}
  };

  var _useState17 = useState(initDialogData),
      _useState18 = _slicedToArray(_useState17, 2),
      dialogData = _useState18[0],
      setDialogData = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      openTypeDialog = _useState20[0],
      setOpenTypeDialog = _useState20[1];

  var isBillboardTypeModifiedRef = useRef(false);
  var fetchBillboardTypesRef = useRef(false);

  var handleOpenDialog = function handleOpenDialog(mode) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setDialogData({
      mode: mode,
      data: data
    });
  };

  var handleCloseDialog = function handleCloseDialog(act) {
    setDialogData(initDialogData);
    if (act === 'confirm') fetchBillboardList();
  };

  var handleToggleStatus = function handleToggleStatus(data, val) {
    var commitData = _.clone(data);

    var commitFormData = new FormData();

    _.set(commitData, 'isShowLive', val);

    for (var i = 1; i <= 3; i++) {
      var linkUrlKey = "linkUrl".concat(i);
      var linkNameKey = "linkName".concat(i);
      var linkData = {
        index: i - 1,
        linkName: data[linkNameKey] || '',
        linkUrl: data[linkUrlKey] || ''
      };

      _.set(commitData, linkNameKey, linkData.linkName);

      _.set(commitData, linkUrlKey, linkData.linkUrl);
    }

    if (data.pdfPath1) {
      var fileData = {
        path: data.pdfPath1,
        file: null
      };

      _.set(commitData, 'pdfPath1', fileData.path);
    }

    var imageKeyMappings = {
      imagePath1: 1,
      imagePath2: 2,
      imagePath3: 3
    };

    var newImagesData = _.clone(initImagesData);

    var _loop = function _loop(key) {
      if (imageKeyMappings.hasOwnProperty(key) && data[key]) {
        var targetElement = newImagesData.find(function (el) {
          return el.keyNumber === imageKeyMappings[key];
        });

        if (targetElement) {
          targetElement.imagePath = data[key];
          targetElement.show = true;
        }
      }
    };

    for (var key in imageKeyMappings) {
      _loop(key);
    }

    newImagesData.forEach(function (item) {
      if (item.show) {
        if (item.imageFile) {
          commitFormData.append("imageFile".concat(item.keyNumber), item.imageFile);

          _.set(commitData, "imagePath".concat(item.keyNumber), '');
        }
      } else {
        _.set(commitData, "imagePath".concat(item.keyNumber), '');
      }
    });
    editBillboardAPI(contextRoot, true, commitData, commitFormData).then(function () {
      fetchBillboardList();
    }).catch(function (error) {
      console.log(error);
      Progress.done();
    });
  };

  var handleDelete = function handleDelete(singleId) {
    var deleteItems = [];
    if (singleId) deleteItems.push(singleId);else _.forEach(selectedItems, function (id) {
      return deleteItems.push(id);
    });
    PopupDialog.confirm({
      title: t('dlg-delete-billboard'),
      display: t('txt-delete-billboard'),
      cancelText: gt('global.lbl-answer-cancel'),
      confirmText: gt('global.lbl-answer-ok'),
      act: function act(confirmed) {
        if (confirmed) {
          deleteMultipleBillboardAPI(contextRoot, false, deleteItems).then(function (result) {
            fetchBillboardList();
            setSelectedItems([]);
          });
        }
      }
    });
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var fetchBillboardList = function fetchBillboardList() {
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    getBillboardList(contextRoot, false, keyword, tableSort, offset, rowsPerPage, curTypeId).then(function (result) {
      if (result.totalElements !== totalCount) setTotalCount(result.totalElements);

      var newData = _.cloneDeep(result.content);

      _.map(newData, function (el, index) {
        el.sequence = offset + index + 1;
      });

      setTableData(newData);
    });
  };

  var handleIsBillboardTypeModified = function handleIsBillboardTypeModified(modified) {
    isBillboardTypeModifiedRef.current = modified;
  };

  var handleCloseTypeDialog = function handleCloseTypeDialog() {
    if (isBillboardTypeModifiedRef.current) {
      fetchBillboardList();
      isBillboardTypeModifiedRef.current = false;
    }

    setOpenTypeDialog(false);
  };

  useEffect(function () {
    fetchBillboardList();
  }, [keyword, JSON.stringify(tableSort), currentPage, rowsPerPage, curTypeId]);
  useEffect(function () {
    if (!contextRoot || fetchBillboardTypesRef.current || !_.isEmpty(billboardTypeList)) return;
    fetchBillboardTypesRef.current = true;

    if (_.isEmpty(billboardTypeList)) {
      getBillboardTypeList(contextRoot, false).then(function (result) {
        var newBillboardTypeList = _.map(result.content, function (el) {
          return {
            value: _.trim(el.id),
            text: el.name
          };
        });

        dispatch(setBillboardTypeList(newBillboardTypeList));
      }).catch(function () {
        fetchBillboardTypesRef.current = false;
      });
    }
  }, [contextRoot, billboardTypeList, dispatch]);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'billboardTypeId', {
    label: t('lbl-billboard-type'),
    sortable: false,
    formatter: function formatter(val, row) {
      var type = _.find(billboardTypeList, function (e) {
        return e.value === val;
      });

      return _.isEmpty(type) ? '' : type.text;
    }
  });

  _.set(fields, 'title', {
    label: t('lbl-title'),
    sortable: true
  });

  _.set(fields, 'description', {
    label: t('lbl-description'),
    sortable: true,
    formatter: function formatter(val, row) {
      if (_.isEmpty(val)) return null;

      var textAry = _.split(val, /\r?\n/g);

      return textAry.length > 1 ? textAry[0] + '...' : val;
    }
  });

  _.set(fields, 'createdAt', {
    label: t('lbl-createdAt'),
    sortable: true
  });

  _.set(fields, 'beginTime', {
    label: t('lbl-beginTime'),
    sortable: true
  });

  _.set(fields, 'endTime', {
    label: t('lbl-endTime'),
    sortable: true
  });

  _.set(fields, 'isShowLive', {
    label: t('lbl-isShowLive'),
    sortable: true,
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(ToggleBtn, {
        onChange: function onChange(val) {
          return handleToggleStatus(row, val);
        },
        on: !!val
      });
    }
  });

  _.set(fields, 'more', {
    label: t('lbl-more'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "icon-block"
      }, /*#__PURE__*/React.createElement("a", {
        title: t('lbl-edit'),
        onClick: function onClick() {
          return handleOpenDialog('edit', row);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-pencil-alt fa-list-alt"
      })), /*#__PURE__*/React.createElement("a", {
        title: t('lbl-delete'),
        onClick: function onClick() {
          return handleDelete(row.id);
        },
        className: "delete"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-trash"
      })));
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "billboard-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-billboard-title')), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-billboard-type'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-type-list'),
    list: billboardTypeList,
    value: curTypeId,
    onChange: function onChange(value) {
      setCurTypeId(value);
      setCurrentPage(0);
    },
    width: '200px'
  }), /*#__PURE__*/React.createElement("a", {
    className: "icon",
    style: {
      marginLeft: '4px'
    },
    onClick: function onClick() {
      return setOpenTypeDialog(true);
    },
    title: t('lbl-billboard-type-setting')
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-cog"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "tooltip-bar"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchIconPosition: "right",
    placeholder: "Search",
    onSearch: function onSearch(search) {
      setKeyword(search);
    }
  }), /*#__PURE__*/React.createElement("a", {
    className: "create-billboard-btn",
    onClick: function onClick() {
      return handleOpenDialog('create');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-plus"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: tableData,
    sort: tableSort,
    onSort: function onSort(sort) {
      return setTableSort(sort);
    },
    rowIdField: "id",
    selectable: {
      toggleAll: true
    },
    selected: selectedItems,
    onSelectionChange: function onSelectionChange(val) {
      return setSelectedItems(val);
    }
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: gt('global.lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: function onChangePage(e, newPage) {
      return setCurrentPage(newPage);
    },
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }), /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, /*#__PURE__*/React.createElement("button", {
    className: cx('button', 'delete'),
    onClick: function onClick() {
      return handleDelete();
    },
    disabled: selectedItems.length > 0 ? false : true
  }, t('lbl-delete')))), /*#__PURE__*/React.createElement(BillboardEdit, {
    dialogData: dialogData,
    onClose: handleCloseDialog
  }), openTypeDialog && /*#__PURE__*/React.createElement(BillboardTypeSetting, {
    id: "g-billboard-type-detail",
    handleIsModified: handleIsBillboardTypeModified,
    onClose: handleCloseTypeDialog
  }));
};

Billboard.defaultProps = {
  id: 'g-setting-billboard'
};
Billboard.PropTypes = {
  id: PropTypes.string
};
export default Billboard;